<template>
  <div data-v-f531b812="" class="apply-agent">
    <div class="head_area">
      <div class="leftImg">
        <van-icon name="arrow-left" @click="$router.back()" />
      </div>
      <span class="head_text">{{ $t('合营计划') }}</span>
      <span class="right_menu"></span>
    </div>

    <div class="pahsn">
      <div class="apply-title">{{ $t('代理联盟') }}</div>
      <div class="apply-desc">{{ $t('始于成功') }},{{ $t('臻于卓越') }},{{ $t('鲤跃龙门') }},{{ $t('投资传奇') }}</div>
      <img src="/static/image/new/applyagen-bg.png?v=1" class="banner-img" alt="">
      <div class="bsd">
        <div @click="$parent.openKefu" class="zixun">
          <img data-v-56fcd294="" src="/static/image/new/applyagen-icon.png" />
          <div class="cnets">
            <div class="tos">{{ $t('合营部') }}</div>
            <div class="bos">{{ $t('立即咨询') }}</div>
          </div>
          <div class="zusnb">{{ $t('咨询') }}</div>
        </div>
        <div class="form-box">
          <div class="form-item">
            <div class="label">{{ $t('用户名') }}</div>
            <div class="value">
              <input type="text" readonly v-model="$store.state.userInfo.username">
            </div>
          </div>
          <div class="form-item">
            <div class="label">{{ $t('真实姓名') }}</div>
            <div class="value">
              <input type="text" readonly v-model="$store.state.userInfo.realname">
            </div>
          </div>
          <div class="form-item">
            <div class="label">{{ $t('联系方式') }}</div>
            <div class="value">
              <input type="text" v-model="info.mobile" :placeholder="$t('请输入您的联系方式')" >
            </div>
          </div>
          <div class="form-item">
            <div class="label">{{ $t('申请理由') }}</div>
            <div class="value">
              <input type="text" v-model="info.apply_info" :placeholder="$t('请输入申请理由')" >
            </div>
          </div>
        </div>
        <div class="submit" @click="shenqing">{{ $t('加入我们') }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import {translateText} from "../common/utils";

export default {
  name: 'applyagent',
  data() {
    return {
      info: {},
    };
  },
  created() {
    let that = this;
  },
  methods: {
    async showTost(type = 0, title) {
      const message = await translateText([title]);
      this.$parent.showTost(type, message[0]);
    },
    shenqing() {
      let that = this;
      let info = that.info;
      let regExp = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      if (!regExp.test(info.mobile)) {
        that.showTost(0, that.$t('请输入正确手机号'));
        return;
      }

      if (!info.apply_info) {
        that.showTost(0, that.$t('请输入申请理由'));
        return;
      }

      that.$parent.showLoading();
      that.$apiFun
        .post('/api/applyagentdo', info)
        .then(res => {
          that.showTost(1, res.message);
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
.apply-agent {
  background: #000;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
  color: #fff;
  font-family: PingFang SC;
  position: relative;
  &::after {
    content: '';
    width: 2.64rem;
    height: 2.64rem;
    background: #731C17;
    filter: blur(1.6rem);
    position: absolute;
    bottom: 0rem;
    right: -.8rem;
    z-index: 2;
  }
  .head_area {
    position: relative;
    z-index: 2;
    height: 1.33333rem;
    display: flex;
    align-items: center;
    padding: 0 .4rem;
    .leftImg {
      flex: 1;
      text-align: left;
      font-size: .48rem;
    }
    .top_back {
      width: 0.26rem;
      height: 0.37333rem;
    }
    .head_text {
      font-size: 0.48rem;
      color: #fff;
      width: 45%;
      text-align: center;
    }
    .right_menu {
      font-size: 0.37333rem;
      color: #fff;
      flex: 1;
      text-align: right;
    }
  }
  .pahsn {
    flex: 1;
    overflow: auto;
    padding: 0.1rem .4rem .4rem;
    .apply-title {
      font-family: FZLanTingHeiS-H-GB;
      font-size: 0.69rem;
      color: #E2E7FF;
      text-align: center;
    }
    .apply-desc {
      margin: .13rem .6rem .05rem;
      height: 0.69rem;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.32rem;
      background: linear-gradient(to left, rgba(181, 187, 248, 0), #4B5BF1, rgba(181, 187, 248, 0));
    }
    .bsd {
      width: 100%;
      border-radius: .27rem;
      padding: .27rem .27rem .4rem;
      background: rgba(255, 255, 255, 0.10);
      border: 0.03rem solid rgba(255, 255, 255, 0.10);
      margin-top: -2.4rem;
      .zixun {
        width: 100%;
        background: rgba(0, 0, 0, 0.30);
        border: 0.03rem solid rgba(255, 255, 255, 0.10);
        border-radius: .21rem;
        display: flex;
        align-items: center;
        position: relative;
        height: 1.47rem;
        padding: .32rem;
        img {
          width: 0.85rem;
          margin-right: .27rem;
        }
        .cnets {
          flex: 1;
          border-left: 0.03rem solid #3D3748;
          padding-left: .27rem;
          .tos {
            font-size: .32rem;
            color: #AEAEAE;
          }
          .bos {
            font-size: .37rem;
          }
        }
        .zusnb {
          width: 1.33rem;
          height: 0.67rem;
          line-height: .67rem;
          text-align: center;
          font-size: 0.32rem;
          color: #fff;
          background: linear-gradient(to bottom, #4B5BF1 40%, #B5BBF8);
          border-radius: .11rem;
        }
      }
      .form-box {
        .form-item {
          display: flex;
          align-items: center;
          background: rgba(0, 0, 0, 0.30);
          border: 0.03rem solid rgba(255, 255, 255, 0.10);
          height: 1.17rem;
          border-radius: .27rem;
          margin-top: .27rem;
          padding: 0 .32rem;
          .label {
            width: 2.2rem;
            font-size: 0.34rem;
          }
          .value {
            input {
              border: none;
              outline: none;
              background: transparent;
              font-size: 0.32rem;
            }
          }
        }
      }
      .submit {
        margin-top: .43rem;
        height: 1.23rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(to bottom, #4B5BF1 40%, #B5BBF8);
        border-radius: .6rem;
        font-size: 0.43rem;
        font-weight: bold;
        position: relative;
        z-index: 3;
      }
    }

    .banner-img {
      width: 100%;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/applyagent.vue